import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userInfo: localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.userInfo = action.payload;
      localStorage.setItem("userInfo", JSON.stringify(action.payload));
    },
    logout: (state, action) => {
      try {
        state.userInfo = null;
        state.newOrders = null;
        localStorage.removeItem("userInfo");
        localStorage.removeItem("newOrders");
        if (localStorage.getItem("userInfo") !== null) {
          localStorage.removeItem("userInfo");
          state.userInfo = null;
        }
      } catch (e) {
        localStorage.removeItem("userInfo");
        localStorage.removeItem("newOrders");
        state.userInfo = null;
        state.newOrders = null;
      }
    },
  },
});

export const { setCredentials, logout } = authSlice.actions;

export default authSlice.reducer;
